const getVariantIndexFromKey = (source) => {
  if (!source) {
    return null;
  }
  const match = source.match(/legal-content-variant(\d+)/);
  return match ? Number(match[1]) : null;
};

const filterLegalContentVariantsInSchema = (schema, data) => {
  if (!schema || !schema.length) {
    return schema;
  }

  return schema.map((section) => {
    if (section.id !== "codes-legal") {
      return section;
    }

    const groupsSource = section.groups || section.children || [];

    const schemaVariantIndices = new Set(
      groupsSource
        .map((group) => getVariantIndexFromKey(group.id))
        .filter((idx) => idx !== null)
    );

    if (!schemaVariantIndices.size) {
      return section;
    }

    const nonEmptyIndices = new Set(
      Object.entries(data || {})
        .filter(
          ([key, value]) =>
            /^codes-legal\/legal-content-variant\d+\/variant-name$/.test(key) &&
            value &&
            String(value).trim()
        )
        .map(([key]) => getVariantIndexFromKey(key))
        .filter((idx) => idx !== null)
    );

    const emptyOrMissing = [...schemaVariantIndices].filter(
      (idx) => !nonEmptyIndices.has(idx)
    );

    const firstEmptyIndex =
      emptyOrMissing.length > 0 ? Math.min(...emptyOrMissing) : null;

    const visibleIndices = new Set(nonEmptyIndices);
    if (firstEmptyIndex !== null) {
      visibleIndices.add(firstEmptyIndex);
    }

    let groups = groupsSource.filter((group) => {
      const idx = getVariantIndexFromKey(group.id);
      if (idx === null) {
        return true;
      }
      return visibleIndices.has(idx);
    });

    if (firstEmptyIndex !== null) {
      const emptyIdxInArray = groups.findIndex((group) => {
        const idx = getVariantIndexFromKey(group.id);
        return idx === firstEmptyIndex;
      });

      if (emptyIdxInArray !== -1) {
        const newGroups = [...groups];
        const [emptyGroup] = newGroups.splice(emptyIdxInArray, 1);
        newGroups.push(emptyGroup);
        groups = newGroups;
      }
    }

    return {
      ...section,
      children: groups,
      groups,
    };
  });
};

export default filterLegalContentVariantsInSchema;
